import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Api from '../../component/Api';


import '../../Assets/student/studentlogin.css';
import logo from '../../Assets/img/logo-small.png';

const Login = () => {
  const navigate = useNavigate();
  const { http } = Api();

  localStorage.removeItem('token');

  const [isRedirecting, setIsRedirecting] = useState(false);
  //login
  const [showPassword, setShowPassword] = useState(false);
  //registration
  const [apaarNo, setApaar] = useState('');
  const [emailId, setEmail] = useState('');
  const [validationRegMessage, setValidationRegMessage] = useState('');
  const [error1, setRegerror] = useState('')
  const [success, setSuccess] = useState('')

  const validateForm = () => {
    const setErrors = {};

    if (!apaarNo && !emailId) {
      setErrors.general = '*Please enter all required fields';
    }
    else {
      if (!apaarNo) {
        setErrors.apaarNo = '*ApaarNo No. required';
      }
      else if (!/^\d{12}$/.test(apaarNo)) {
        setErrors.apaarNo1 = '*Apaar No. number must be 12 digits';
      }

      if (!emailId) {
        setErrors.email = '*Email ID required';
      }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailId)) {
        setErrors.email = '*Invalid email format';
      } else if (emailId.length > 50) {
        setErrors.email = '*Email ID must not exceed 50 characters';
      }
    }
    setValidationRegMessage(setErrors);
    return Object.keys(setErrors).length === 0;

  };


  //register

  const handleRegister = (e) => {
    e.preventDefault();
    setValidationRegMessage('');
    setSuccess('');


    if (validateForm()) {
      setIsRedirecting(true); // Set redirecting to true before making the API call

      http.post('/forgotPassword', {
        apaar_no: apaarNo,
        student_email: emailId
      })
        .then(response => {
          // console.log("Response:", response);
          if (response.data.status_code === "MSG11") {
            setSuccess(response.data.message);
            setRegerror('');
          }
          else {
            setRegerror(response.data.message);
          }
        })
        .catch(error => {
          const errorMessage = error.response?.data?.message || 'An error occurred';
          setRegerror(errorMessage);
          // console.log(error);
          // console.log("res=", error.response?.data?.message);
        })
        .finally(() => {
          setIsRedirecting(false); // Set redirecting back to false after the API call completes
        });
    }
  };


  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };



  return (
    <>
      {isRedirecting ? (

        <div className='body23'>
          <div className="container23">
            <div className="login-box23" style={{ minHeight: "50%", alignContent: "center" }}>
              <div className="card-body d-flex justify-content-center align-items-center" >
                <div className="containeranimate">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>

            </div>
          </div>
        </div>

      ) : (
        <>
          <div className='body23'>
            <div className="container23">
              <div className="login-box23">
                <div className="circle23">
                  <img className="img-fluid for-light" src={logo} alt="MGU Logo" />
                </div>

                    <div className="heading12">Forgot Password</div>
                    <form onSubmit={handleRegister}>
                      <div>
                        <input
                          type="text"
                          className={`input-field23 ${validationRegMessage.apaarNo ? 'error12' : ''}`}
                          placeholder="APAAR No. *"
                          value={apaarNo}
                          maxLength={12}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {  // Regular expression to allow only digits
                              setApaar(value);
                            }
                          }}
                          pattern="\d*"
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          className={`input-field23 ${validationRegMessage.email ? 'error12' : ''}`}
                          placeholder="Email ID *"
                          value={emailId}
                          onChange= {(e)=> setEmail(e.target.value)}
                          
                        />
                      </div>
                      <div>
                       

                        {validationRegMessage.general && (
                          <span className="validation-message">
                            {validationRegMessage.general}
                          </span>
                        )}

                        {validationRegMessage.apaarNo && (
                          <span className="validation-message">
                            {validationRegMessage.apaarNo}
                          </span>
                        )}
                        {validationRegMessage.apaarNo1 && (
                          <span className="validation-message">
                            {validationRegMessage.apaarNo1}
                          </span>
                        )}


                        {validationRegMessage.email && (
                          <span className="validation-message">
                            {validationRegMessage.email}
                          </span>
                        )}
                       

                        {error1 && (
                          <span className="validation-message">
                            {error1}
                          </span>
                        )}

                        {success && (
                          <span className="success-message">
                            {success}
                          </span>
                        )}

                      </div>
                      <div className="form-group23">
                        <label className="remember-label23">
                          <a href="/" className="forgot-password23">
                            Back to Login
                          </a>
                        </label>
                      </div>
                      <button type="submit" className="submit-btn23">
                        Submit
                      </button>
                    </form>
                 
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Login;